import React, { useEffect } from 'react';

import { useMediaQuery } from '@mui/material';
import { hotjar } from 'react-hotjar';

import Logo from 'public/assets/mainLogo.png';

import NewNavbar from './NewNavbar';

const NewWrapper = ({ children }: any) => {
  const isMedia920px = useMediaQuery('(max-width : 920px)');
  useEffect(
    () =>
      hotjar.initialize(
        Number(process.env.HOTJAR_SITE_ID),
        Number(process.env.HOTJAR_NUMBER)
      ),
    []
  );
  return (
    <div className="h-[100vh] min-h-fit m-0">
      <div className={`h-[10vh] flex items-center`}>
        <NewNavbar />
      </div>

      <div
        className={` flex items-center w-full h-[85vh] overflow-auto ${
          isMedia920px ? 'px-3 py-4' : 'px-6 py-2'
        }`}
      >
        {children}
      </div>
      <footer className="fixed h-fit inset-x-0 bottom-0  justify-center">
        <div className="justify-center py-2 px-4 flex items-center font-normal bg-white">
          <img src={Logo.src} className="w-8 h-8" alt="" />
          <div className="text-xs text-[#777777] pl-2">
            Attention! Fileverse Solo is a proof of concept on how IPFS can work
            for file sharing. Solo is in alpha. Expect upgrades in 2026 💛
          </div>
        </div>
      </footer>
    </div>
  );
};

export default NewWrapper;
